import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "item expmenu"
}
const _hoisted_2 = { class: "button" }
const _hoisted_3 = { class: "exp profilecard" }
const _hoisted_4 = { class: "profile" }
const _hoisted_5 = { class: "avatar" }
const _hoisted_6 = {
  key: 0,
  class: "name"
}
const _hoisted_7 = {
  key: 1,
  class: "name"
}
const _hoisted_8 = { class: "email" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "item" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "item" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "item" }
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  class: "item",
  "data-border": "top"
}

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountUserInfo',
  setup(__props) {

const localizer = Localizer;
const routes = (window as any).App.routes;

const profileInfo = ref<any>({ email: null, isCompany: false });

onBeforeMount(async () => {
    await getData();
});

async function getData() {
    const result = (await Axios.post(routes.Account_User_GetUserInfo)).data;
    profileInfo.value.email = result.email;
    profileInfo.value.name = result.name;
    profileInfo.value.surname = result.surname;
    profileInfo.value.isCompany = result.isCompany;
    profileInfo.value.firstLetters = result.firstLetters;
}

return (_ctx: any,_cache: any) => {
  const _component_app_accountlogout = _resolveComponent("app-accountlogout")!
  const _directive_exp_menu = _resolveDirective("exp-menu")!

  return (profileInfo.value.email)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("button", { class: "overlay" }, [
          _createElementVNode("span", {
            class: "icon fastic-close",
            role: "button"
          })
        ], -1)),
        _createElementVNode("button", _hoisted_2, _toDisplayString(profileInfo.value.firstLetters), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(profileInfo.value.firstLetters), 1),
            (!profileInfo.value.isCompany)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(profileInfo.value.name) + " " + _toDisplayString(profileInfo.value.surname), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(profileInfo.value.name), 1)),
            _createElementVNode("div", _hoisted_8, _toDisplayString(profileInfo.value.email), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", {
              href: _unref(routes).MyBeghelliDashboard_Dashboard,
              class: "button"
            }, _toDisplayString(_unref(localizer).get('App.MyBeghelli.Dashboard')), 9, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              href: _unref(routes).MyBeghelliOrder_OrderList,
              class: "button"
            }, _toDisplayString(_unref(localizer).get('App.Common.MyOrders')), 9, _hoisted_12)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              href: _unref(routes).MyBeghelliProfile_AccountEdit,
              class: "button"
            }, _toDisplayString(_unref(localizer).get('Account.Common.AccountSecurity')), 9, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", {
              href: _unref(routes).MyBeghelliProfile_ProfileEdit,
              class: "button"
            }, _toDisplayString(_unref(localizer).get('Account.Common.PersonalData')), 9, _hoisted_16)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sep" }, null, -1)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_app_accountlogout)
          ])
        ])
      ])), [
        [_directive_exp_menu]
      ])
    : _createCommentVNode("", true)
}
}

})